import { jsPDF } from 'jspdf';
// These were both created using https://peckconsulting.s3.amazonaws.com/fontconverter/fontconverter.html
import * as Roboto from './Roboto-Regular-normal.js';
import * as RobotoBold from './Roboto-Bold-normal.js';
import 'svg2pdf.js';
import { DateTime } from "luxon";
import { getCountryId, updateSelectedCountry, getLocationDisplayName } from "./locations";
import { pluralize, pct, getLastItem } from "./utils";
import {
  CHART_DATE_FORMAT_MONTH,
  CHART_DATE_FORMAT_DATE_SHORT,
  CHART_DATE_FORMAT_YEAR_SHORT
} from "./constants";

import logoSvgRaw from './style/icons/fathom-one.svg?raw';

const body = document.querySelector("body");
let svg;

let data;
let gridView;
let pdfChangeChartMode;
let getChartMode;
let redraw;
let drawCurveChart;
let getDisplayName;
let getLineageColor;
let showLoader, hideLoader, updateLoaderMessage;
let lineageThreshold;
let startDate, endDate, updateDate;

let currentChartMode;

let bottomMargin = 2;

//const PDFDocument = require('pdfkit');
//import { blobStream } from 'blob-stream';

export function initPdf(
  _data,
  _pdfChangeChartMode,
  _getChartMode,
  _redraw,
  _drawCurveChart,
  _getDisplayName,
  _getLineageColor,
  _showLoader,
  _hideLoader,
  _updateLoaderMessage,
  _lineageThreshold,
  _startDate,
  _endDate,
  _updateDate
) {

  data = _data;
  pdfChangeChartMode = _pdfChangeChartMode;
  getChartMode = _getChartMode;
  redraw = _redraw;
  drawCurveChart = _drawCurveChart;
  getLineageColor = _getLineageColor;
  showLoader = _showLoader;
  hideLoader = _hideLoader;
  updateLoaderMessage = _updateLoaderMessage;
  lineageThreshold = _lineageThreshold;
  startDate = _startDate;
  endDate = _endDate;
  updateDate = _updateDate;
  getDisplayName = _getDisplayName;


  document.querySelectorAll(".pdf.action").forEach(link => {
    link.addEventListener("click", async () => {

      if (document.body.classList.contains("gridView")) {
        gridView = true;
      }
      console.log('gridView', gridView);

      if (gridView) {
        openPdfGridView();
      } else {
        openPdf();
      }
      link.classList.toggle("completed", true);
      setTimeout(() => {
        link.classList.toggle("completed", false);
      }, 5000);
    });
    link.addEventListener("touchstart", async () => {
      if (document.body.classList.contains("gridView")) {
        gridView = true;
      }
      if (gridView) {
        openPdfGridView();
      } else {
        openPdf();
      }
      link.classList.toggle("completed", true);
      setTimeout(() => {
        link.classList.toggle("completed", false);
      }, 5000);
    }, {passive:true});

  });
}


function getPdfFilename() {
  let title = ``;
  data.locations.forEach(l => {
    title += getCountryId(getLocationDisplayName(l));
    title += `_`;
  });


  let now = DateTime.now();

  let pdfFilename = `banyan_contour_${ title }${now.toFormat('yyLLdd')}.pdf`;
  console.log(pdfFilename);
  return pdfFilename;
}

function openPdf() {

  showLoader();
  updateLoaderMessage("Building PDF");

  currentChartMode = getChartMode();

  // Setup the PDF

  console.log('openPdf');

  const doc = new jsPDF({
    unit: "px",
    orientation: "landscape",
    hotfixes: ["px-scaling"]
  });

  // doc.setFont('Roboto-Regular', 'normal');
  // console.log(doc.getFontList());
  // console.log('font',doc.getFontSize());//16

  doc.addPage(2);
  doc.addPage(3);


  let width = doc.internal.pageSize.getWidth();
  let height = doc.internal.pageSize.getHeight();
  let aspect = height / width;
  // console.log(`PDF width, height, aspect: ${  width  }, ${  height  }, ${  aspect}`);


  // Setup the document for pdf mode

  body.classList.toggle("pdf-export", true);
  // console.log(width, height);
  body.style.width = `${ width * 2 }px`;
  body.style.height = `${ (height * 2) - bottomMargin }px`; // keep it on the page




  drawPdfFeatureSidebar(data);

  drawPdfSourcesFooter();

  // return;

  // Pick up any images that don't have a 'src', and instead use css 'content', and swap their src out
  body.querySelectorAll("img").forEach(img => {
    let cs = getComputedStyle(img);
    if (cs.content && cs.content !== "normal") {
      let src = cs.content.replace(/url\("/gi, "").replace(/"\)/gi, "");
      console.log(src);
      img.src = src;
    }
  });




  // return;

  let promises = [];

  promises.push(new Promise(resolve => {

    // Chain these together, as jsPdf + .html() don't like to do things in parallel

    drawPdfPctChart(doc, body, width, height)
      .then(() => {
        drawFlagSvgs(doc, 1)
          .then(() => {
            drawSvgFathomLogo(doc, 1)
              .then(() => {
                drawPdfBarChart(doc, body, width, height)
                  .then(() => {
                    drawFlagSvgs(doc, 3)
                      .then(() => {
                        drawSvgFathomLogo(doc, 3)
                          .then(() => {
                            drawPdfCurveChart(doc, body, width, height, resolve);
                          });
                      });
                  });
              });
          });
      });
  }));

  Promise.all(promises)
    .then(() => {


      console.log('all promises complete');
      doc.save(getPdfFilename());
      cleanup();
      // console.log('currentChartMode', currentChartMode);
      pdfChangeChartMode(currentChartMode);
    });


}

function openPdfGridView() {

  showLoader();
  updateLoaderMessage("Building PDF");

  currentChartMode = getChartMode();

  // Setup the PDF

  console.log('openPdfGridView');

  const doc = new jsPDF({
    unit: "px",
    orientation: "landscape",
    hotfixes: ["px-scaling"]
  });

  // doc.addPage(2);
  // doc.addPage(3);



  let width = doc.internal.pageSize.getWidth();
  let height = doc.internal.pageSize.getHeight();
  let aspect = height / width;
  // console.log(`PDF width, height, aspect: ${  width  }, ${  height  }, ${  aspect}`);


  // Setup the document for pdf mode

  body.classList.toggle("pdf-export", true);
  // console.log(width, height);
  body.style.width = `${ width * 2 }px`;
  body.style.height = `${ (height * 2) - bottomMargin }px`; // keep it on the page



  // drawPdfFeatureSidebar(data);
  // drawPdfSubvariantsSidebar(data);
  drawPdfSourcesFooter();


  let gridCharts = document.querySelectorAll("#grid .grid-element");
  let numGridCharts = gridCharts.length;

  let numPages = Math.ceil(numGridCharts/6) * 3; // all 3 chart styles
  for (let x = 2; x <= numPages; x++) {
    doc.addPage(x);
  }




  // return;

  // let serialPromises = [];
  //
  // let p = Promise.resolve();
  //
  // serialPromises.push(() => drawPdfPctChart(doc, body, width, height));
  // serialPromises.push(() => drawFlagSvgs(doc, 1));
  // serialPromises.push(() => drawSvgFathomLogo(doc, 1));
  //
  // serialPromises.forEach(promise => {
  //   p = p.then(() => { promise() });
  // });
  //
  // //return p;
  //
  //
  // Promise.all(p)
  //   .then(() => {
  //
  //     console.log('all promises complete');
  //     doc.save(getPdfFilename());
  //     cleanup();
  //   });


  let promises = [];

  promises.push(new Promise(resolve => {

    // Chain these together, as jsPdf + .html() don't like to do things in parallel

    drawPdfPctChart(doc, body, width, height)
      .then(() => {
        drawFlagSvgs(doc, 1)
          .then(() => {
            drawSvgFathomLogo(doc, 1)
              .then(() => {
                drawPdfBarChart(doc, body, width, height)
                  .then(() => {
                    drawFlagSvgs(doc, 3)
                      .then(() => {
                        drawSvgFathomLogo(doc, 3)
                          .then(() => {
                            drawPdfCurveChart(doc, body, width, height, resolve);
                          });
                      });
                  });
              });
          });
      });
  }));

  Promise.all(promises)
    .then(() => {

      console.log('all promises complete');
      doc.save(getPdfFilename());
      cleanup();

      // console.log('currentChartMode', currentChartMode);
      pdfChangeChartMode(currentChartMode);
    });


}



function updateFlagImgSrcs() {

  // console.log(body);

  // Pick up any images that don't have a 'src', and instead use css 'content', and swap their src out
  body.querySelectorAll("img").forEach(img => {

    // console.log(img);
    let cs = getComputedStyle(img);
    // console.log(img, cs);
    if (cs.content && cs.content !== "normal" && !img.src) {
      let src = cs.content.replace(/url\("/gi, "").replace(/"\)/gi, "");

      // console.log(src);
      img.src = src;

      // console.log(img.src);

      // let bb = img.getBoundingClientRect();
      // img.setAttribute("height", bb.height);
      // img.setAttribute("width", bb.width);
    }
  });

  // console.log(body.querySelectorAll("img"));
  // body.querySelectorAll("img").forEach(img => {
  //   console.log(img, img.src);
  // });


}



function drawFlagSvgs(doc, page) {

  doc.setPage(page);

  let svgs = document.querySelectorAll(".flag img");
  // console.log('flag svgs', svgs);

  function drawSvg(_svg, renderedRect) {

    //let renderedRect = _svg.getBoundingClientRect();

    // console.log('drawing svg');

    return doc.svg(_svg, {
      x:renderedRect.left/2,
      y:renderedRect.top/2,
      width:renderedRect.width/2,
      height:renderedRect.height/2
    });

  }

  let flagSvgsToDraw = [];
  let fetchPromises = [];

  svgs.forEach((svg, i) => {
    let cs = getComputedStyle(svg);
    let renderedRect = svg.getBoundingClientRect();
    if (cs.content && cs.content.match(/\.svg/gi)) {
      // console.log(cs.content, svg);
      let src = cs.content.replace(/url\("/gi, "").replace(/"\)/gi, "");
      console.log('loading svg', src);
      fetchPromises.push(
        fetch(src)
          .then(res => res.text())
          .then(svgData => {
            // console.log(svgData);

            // let dataTokens = svgData.split("<?xml version=\"1.0\" encoding=\"UTF-8\"?>");
            // let data = dataTokens[1];

            let data = svgData;

            let div = document.createElement("div");
            div.classList.toggle("hidden", true);
            div.classList.toggle("cleanup", true);
            document.body.appendChild(div);
            div.innerHTML = data;

            flagSvgsToDraw.push({
              renderedRect : renderedRect,
              svgEl : div.querySelector("svg")
            });
          })
      )
    }
    // p = p.then(() => drawSvg(svg, i));
  });

  let p = Promise.resolve();

  return Promise.all(fetchPromises)
    .then(() => {
      // console.log('svg data retrieved', flagSvgsToDraw);
      flagSvgsToDraw.forEach(svg => {
        p = p.then(() => drawSvg(svg.svgEl, svg.renderedRect));
      });
      return p;
    });

  //return p;

}


function drawPdfPctChart(doc, body, width, height) {
  pdfChangeChartMode("pct");

  showLoader();

  drawPdfSubvariantsSidebar(data);

  updateFlagImgSrcs();

  drawPdfTitle(data, "Proportion of SARS-CoV-2 genomes by week from ");

  console.log('pct mode');
  return doc.html(body, {

    x:0,
    y:0, // Put it on the 1st page

    html2canvas: {
      //scale:htmlFactor / 2,
      scale: 0.5,
      width: width,
      height: height,
      windowWidth: width*2,
      windowHeight: height*2,

      letterRendering: true,

      allowTaint: true,
      useCORS: true,

      // Ignore SVGs and Imgs that don't have src, to avoid errors
      ignoreElements: el => {
        let ignore = false;

        if (el.id === "loader") {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'svg') {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'img' && !el.src) {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'img' && el.src && el.src.match(/\.svg/gi)) {
          ignore = true;
        }
        return ignore;
      }
    }
  });
}


function drawPdfCurveChart(doc, body, width, height, resolve) {

  console.log("curve mode");
  pdfChangeChartMode("curve");

  showLoader();

  drawPdfSubvariantsSidebar(data);

  updateFlagImgSrcs();

  drawPdfTitle(data, "Growth of SARS-CoV-2 genomes modeled through ", true);

  // Pick up boundingClientRects here, before we start mucking with css and the dom,
  // so that positioning on the pdf later is accurate
  let svgs = document.querySelectorAll(".graphic svg");
  let svgRects = [];
  svgs.forEach(svg => {
    svgRects.push(svg.getBoundingClientRect());
  });



  let location = data.locations[0];


  const styles = [];

  let stylesheet;
  for (let x = 0; x < document.styleSheets.length; x++) {
    if (document.styleSheets[x].href.match(/assets\/index|main.less/gi)) {
      stylesheet = document.styleSheets[x];
    }
  }

  let ruleList = stylesheet.cssRules;
  for (let i = 0; i < ruleList.length; i++) {
    //console.log(i, ruleList[i]);

    if (ruleList[i].selectorText && ruleList[i].selectorText.match(/chartLayer|dotsLayer|linesLayer|dotsHighlightLayer|conesHighlightLayer|linesHighlightLayer|confidenceArea|chartLine|stderrDot|subvariantDotsHighlightLayer/gi)) {
      styles.push(ruleList[i].cssText);
    }
  }


  svgs.forEach((svg, i) => {

    //svg = body.querySelector("#graphic svg");
    // let svgRect;
    if (svg) {
      // svgRect = svg.getBoundingClientRect();
      // console.log('svgRect', svgRect);

      //let renderedRect = document.querySelector("#graphic").getBoundingClientRect();
      //let renderedRect = svg.closest(".graphic").getBoundingClientRect();

      // console.log(svg.getBoundingClientRect());

      let renderedRect = svgRects[i];

      // console.log('renderedRect', renderedRect);
      // console.log(renderedRect.height + renderedRect.top);

      // svg.setAttribute("width", svgRect.width * factor);
      // svg.setAttribute("height", svgRect.height * factor);
      //svg.setAttribute("viewBox", `0, 0, ${   svgRect.width  }, ${   svgRect.height }`);
      svg.setAttribute("viewBox", `0, 0, ${   renderedRect.width  }, ${   (renderedRect.height)}`);


      let style = document.createElement("style");
      style.innerHTML = styles.join(" ");
      svg.appendChild(style);

      // console.log(svg);

      // svg.setAttribute("width", width/2);
      // svg.setAttribute("height", height);
      // svg.removeAttribute("width");
      // svg.removeAttribute("height");

      //console.log(svg.outerHTML);

    }

  });



  doc.html(body, {

    x:0,
    y:height + 1, // Put it on the 2nd page

    html2canvas: {
      //scale:htmlFactor / 2,
      scale: 0.5,
      width: width,
      height: height,
      windowWidth: width*2,
      windowHeight: height*2,

      allowTaint: true,
      useCORS: true,

      letterRendering: true,

      // Ignore SVGs and Imgs that don't have src, to avoid errors
      ignoreElements: el => {
        let ignore = false;
        if (el.id === "loader") {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'svg') {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'img' && !el.src) {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'img' && el.src && el.src.match(/\.svg/gi)) {
          ignore = true;
        }
        return ignore;
      }
    }
  }).then(() => {

    function drawSvg(_svg, i) {

      let renderedRect = svgRects[i];

      return doc.svg(_svg, {
        x:renderedRect.left/2,
        y:renderedRect.top/2,
        width:renderedRect.width/2,
        height:renderedRect.height/2
      });

    }

    // Forces synchronous rendering of the svgs, as they won't draw in parallel
    function drawSvgs() {
      let p = Promise.resolve();
      svgs.forEach((svg, i) => {
        p = p.then(() => drawSvg(svg, i));
      });
      return p;
    }

    drawFlagSvgs(doc, 2)


      .then(() => {
        console.log('drawFlagSvgs complete');
        drawSvgs()
          .then(() => {
            console.log('drawSvgs Complete');
            drawSvgFathomLogo(doc, 2)
              .then(() => {
                console.log('drawSvgFathomLogo complete')
                resolve();
              })
          });
      });

  });
}


function drawPdfBarChart(doc, body, width, height) {
  pdfChangeChartMode("bar");

  showLoader();

  drawPdfSubvariantsSidebar(data);

  updateFlagImgSrcs();

  drawPdfTitle(data, "Total SARS-CoV-2 genomes by week from ");

  console.log('bar mode');
  return doc.html(body, {

    x:0,
    y:height * 2 + 1, // Put it on the 3rd page

    html2canvas: {
      //scale:htmlFactor / 2,
      scale: 0.5,
      width: width,
      height: height,
      windowWidth: width*2,
      windowHeight: height*2,

      allowTaint: true,
      useCORS: true,

      letterRendering: true,

      // Ignore SVGs and Imgs that don't have src, to avoid errors
      ignoreElements: el => {
        let ignore = false;
        if (el.id === "loader") {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'svg') {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'img' && !el.src) {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'img' && el.src && el.src.match(/\.svg/gi)) {
          ignore = true;
        }
        return ignore;
      }
    }
  });
}

function drawPdfTitle(data, label, isPrediction) {

  if (isPrediction) {


    if (data.locations[0].dailyPredictionData && data.locations[0].dailyPredictionData.length > 0) {

      let predictionEndDate = getLastItem(data.locations[0].dailyPredictionData).date;

      //console.log(data.locations[0]);

      let endDateLabel = `${ predictionEndDate.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ predictionEndDate.toFormat(CHART_DATE_FORMAT_MONTH) } ${ predictionEndDate.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }`;

      let title = document.querySelector("#pdf-title");
      title.querySelector("h4").innerHTML = `${label + endDateLabel}`;

    }

  } else {

    let yearsMatch = (startDate.get('year') === endDate.get('year'));

    let startDateLabel = `${ startDate.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ startDate.toFormat(CHART_DATE_FORMAT_MONTH) }`;

    if (!yearsMatch) {
      startDateLabel += ` ${ startDate.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }`;
    }

    let endDateLabel = `${ endDate.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ endDate.toFormat(CHART_DATE_FORMAT_MONTH) } ${ endDate.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }`;

    let title = document.querySelector("#pdf-title");
    title.querySelector("h4").innerHTML = `${label + startDateLabel  } - ${  endDateLabel}`;

  }



}

function drawPdfFeatureSidebar(data) {

  let location = data.locations[0];

  let sidebar = document.querySelector("#pdf-feature");


  let feature = sidebar.querySelector(".feature");
  updateSelectedCountry(location, feature);


  let totalEl = sidebar.querySelector(".feature-total-sequences");
  let countryTotal = location.sequencesFiltered;
  totalEl.innerHTML = `<span class="value">${ countryTotal.toLocaleString() }</span>&nbsp;${ pluralize('genome', countryTotal) }`;

  let lineagesEl = sidebar.querySelector(".feature-total-lineages");
  let lineagesTotal = location.validLineages.length;
  lineagesEl.innerHTML = `<span class="value">${ lineagesTotal.toLocaleString() }</span>&nbsp;${ pluralize('lineage', lineagesTotal) } with ${ pct(lineageThreshold, 0, true, true) } or more of genomes`;

}

function drawPdfSubvariantsSidebar(data) {

  let location = data.locations[0];
  let featuredHtml = '';
  let container = document.querySelector("#pdf-sidebar-subvariants");

  let groupedByVariants, groupedByVariantsOthers;

  if (getChartMode() === 'pct' || getChartMode() === 'curve') {
    groupedByVariants = location.groupedByVariantsFilteredByPredictions;
    groupedByVariantsOthers = location.groupedByVariantsOthersFilteredByPredictions;
  } else {
    groupedByVariants = location.groupedByVariants;
    groupedByVariantsOthers = location.groupedByVariantsOthers;
  }

  // console.log(groupedByVariants);
  // console.log(groupedByVariantsOthers);

  let variants = Object.keys(groupedByVariants).filter(v => v !== "Unassigned").map(v => {
    let svs = groupedByVariants[v].map(sv => {
      return {...sv, ...location.subvariantTotals[sv.name]};
    });
    return {
      variant : v,
      subvariants : svs,
      subvariantCount : svs.length,
      totalCount : 0
    }
  });


  let others = {
    variant : 'other',
    subvariants : [{
      name : 'other',
      ...location.subvariantTotals['other']
    }],
    subvariantCount : 0,
    totalCount : 0
  };
  for (const otherVariant in groupedByVariantsOthers) {
    others.subvariantCount += groupedByVariantsOthers[otherVariant].length;
  }
  variants.push(others);


  variants.forEach((variant) => {

    let subvariants = variant.subvariants;
    let subvariantsGroupedByLevels = {};

    subvariants.forEach(subvariant => {

      let level = subvariant.secondLevel;
      if (subvariant.variant && subvariant.variant.name && subvariant.variant.name.match(/delta/gi)) {
        level = subvariant.topLevel;
      }

      subvariantsGroupedByLevels[level] = subvariantsGroupedByLevels[level] || {
        'totalCount' : 0,
        'subvariants' : []
      }

      subvariantsGroupedByLevels[level].subvariants.push(subvariant);
      subvariantsGroupedByLevels[level].totalCount += subvariant.num;

    });

    let subvariantsByLevel = Object.values(subvariantsGroupedByLevels);

    let isGridMode = false;
    if (document.body.classList.contains("gridView")) {
      isGridMode = true;
    }

    if (isGridMode) {
      subvariantsByLevel.sort((a, b) => b.subvariants.length - a.subvariants.length);
    } else {
      subvariantsByLevel.sort((a, b) => b.totalCount - a.totalCount);
    }

    subvariantsByLevel.forEach(level => {
      level.subvariants.sort((a, b) => b.num - a.num);
    });

    subvariantsByLevel.forEach((level, levelCounter) => {
      // console.log(level);

      featuredHtml += `<div class="subvariant-level">`;

      level.subvariants.forEach((subvariant, subvariantCounter) => {

        let subvariantTotal = 0;
        let subvariantPct = 0;
        if (location.subvariantTotals[subvariant.name]) {
          subvariantTotal = location.subvariantTotals[subvariant.name].num;
          subvariantPct = subvariantTotal / location.sequencesFiltered;
        }
        let subvariantDisplay = getDisplayName(subvariant.name);

        if (variant.variant.match(/other/gi)) {
          subvariantDisplay = `${ variant.subvariantCount.toLocaleString() } ${ pluralize('other', variant.subvariantCount)}`;
        }

        let color = getLineageColor(variant.variant, subvariant.name);

        if (isGridMode) {
          featuredHtml += `<div class="subvariant" data-variant="${ variant.variant }" data-lineage="${ subvariant.name }" style="color:${ color }">
                <div class="detail">
                  <div class="chip" style="background-color:${ color }"></div>
                  <h4 class="name">${ subvariantDisplay }</h4>
                </div>
              </div>`;
        } else {
          featuredHtml += `<div class="subvariant" data-variant="${ variant.variant }" data-lineage="${ subvariant.name }" style="color:${ color }">
                <div class="detail">
                  <div class="chip" style="background-color:${ color }"></div>
                  <h4 class="name">${ subvariantDisplay }</h4>
                  <h6 class="count">${ subvariantTotal.toLocaleString() }</h6>
                  <h6 class="count">${ pct(subvariantPct.toLocaleString(), 0, false, true) }</h6>
                </div>
              </div>`;
        }

      });

      featuredHtml += "</div>";

    });



  });

  container.innerHTML = featuredHtml;

}

function drawPdfSourcesFooter() {

  let footer = document.querySelector("#pdf-footer");

  let now = DateTime.now();
  let downloadedDateLabel = `${ now.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ now.toFormat(CHART_DATE_FORMAT_MONTH) } ${ now.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }`;

  footer.querySelector("#pdf-footer-downloaded h6").innerHTML = `Downloaded ${ downloadedDateLabel }`;


  let updateDateLabel = `${ updateDate.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ updateDate.toFormat(CHART_DATE_FORMAT_MONTH) } ${ updateDate.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }`;

  footer.querySelector("#pdf-footer-data-last-updated h6").innerHTML = `Data last updated ${ updateDateLabel }`;

}

function drawSvgFathomLogo(doc, page) {

  doc.setPage(page);

  let logo = document.querySelector("#pdf-footer .fathom .glyph");
  let logoRect = logo.getBoundingClientRect();

  let logoSvgWrapper = document.createElement("div");
  logoSvgWrapper.innerHTML = logoSvgRaw;
  let logoSvg = logoSvgWrapper.querySelector("svg");
  logoSvg.setAttribute("viewBox", `0, 0, ${ logoRect.width } ${ logoRect.height }`);
  logoSvg.setAttribute("fill", "rgb(150, 150, 150)");

  return doc.svg(logoSvg, {
    x:logoRect.left/2 - logoRect.width,
    y:logoRect.top/2 + 4,
    width:logoRect.width,
    height:logoRect.height
  });
}

function cleanup() {

  // return;

  if (svg) {
    svg.removeAttribute("viewBox");
  }

  body.style.width = "";
  body.style.height = "";
  body.classList.toggle("pdf-export", false);

  hideLoader();

  let cleanups = document.querySelectorAll(".cleanup");
  cleanups.forEach(c => {
    c.parentNode.removeChild(c);
  });

  redraw(data);
}
